import { type IModel } from "./IModels";

const TRENDING_SCORE_CUTOFF = 0.5;
export const isModelTrending = ({ trendingScore }: IModel) =>
  trendingScore ? trendingScore > TRENDING_SCORE_CUTOFF : false;
